import { apiClient } from '@/lib/api';
import type { FormTransferImportResponse, FormTransferPackage } from '@skewb-works/contracts';

export async function exportFormPackage(id: number): Promise<FormTransferPackage> {
  return apiClient.get<FormTransferPackage>(`/works-lite/forms/${id}/export`);
}

export async function importFormPackage(
  pkg: FormTransferPackage,
): Promise<FormTransferImportResponse> {
  return apiClient.post<FormTransferImportResponse>('/works-lite/forms/import', pkg);
}
